/* Elite EG: "Find your size with Mevy". The customer enters her height and weight and gets an
approximate 2D drawing of the piece on her body, plus how it fits and where it ends.
Pieces listed in PHOTOS also get real photos of Mevy (one per fit band) with a switch back to the drawing.
Sizes come from the size guide (snippets/elite-size-guide.liquid).
Ways in: the card on the product page (snippets/elite-fit.liquid, with quick height/weight fields), the «مقاسك؟» button
in the sticky bar (sections/elite-styles.liquid), and links with ?mevy=1[&h=160&w=65] (home section, ads) that scroll to the card, prefill it and highlight it (never auto-open the sheet: ahmed 2026-10-24). */
(function () {
'use strict';
var FLOOR = 196;
var REF_H = 162;
var STORE_KEY = 'el_fit_v1';
/* Real-photo Mevy: the same model at 162 cm in one body per fit band (index = band: 0 tight … 4 very roomy),
wearing the piece in one colour. Made on Higgsfield from the Mevy model photo and the product photo;
files live in Shopify (Content > Files). Pieces not listed here keep the drawing only. */
var PHOTO_H = 162;
/* Tape-measured pieces: real numbers by handle override the defaults (max/min in kg, pants len = full length in cm). */
var SPECS = {
'essential-cotton-wide-leg-pants': { max: 80, min: 50, pants: { len: 110 } },
'cloud-set-milton-hoodie-wide-leg-cotton-pants': { max: 80, min: 50, pants: { len: 110 } }
};
var PHOTOS = {
'haven-milton-set': {
c: ['رمادي فاتح', 'light gray'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-haven-b0.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-haven-b1.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-haven-b2.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-haven-b3.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-haven-b4.png'
]
},
'essential-cotton-wide-leg-pants': {
c: ['عنابي', 'burgundy'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-essential-pants-b0.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-essential-pants-b1.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-essential-pants-b2.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-essential-pants-b3.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-essential-pants-b4.png'
]
},
'cropped-jacket-waterproof': {
c: ['أحمر', 'red'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-storm-jacket-b0.png?v=1791589946',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-storm-jacket-b1.png?v=1791589945',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-storm-jacket-b2.png?v=1791589945',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-storm-jacket-b3.png?v=1791589946',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-storm-jacket-b4.png?v=1791589945'
]
},
'muse-off-shoulder-lined-sweatshirt': {
c: ['أسود', 'black'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-muse-b0.png?v=1791589945',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-muse-b1.png?v=1791589945',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-muse-b2.png?v=1791589945',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-muse-b3.png?v=1791589946',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-muse-b4.png?v=1791589946'
]
},
'ridge-gabardine-jacket': {
c: ['أسود', 'black'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ridge-jacket-b0.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ridge-jacket-b1.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ridge-jacket-b2.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ridge-jacket-b3.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ridge-jacket-b4.png'
]
},
'ridge-gabardine-bundle-jacket-cotton-pants': {
c: ['أحمر مع بنطلون رمادي فاتح', 'red with light gray pants'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-ridge-set-b0.png?v=1791666852',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-ridge-set-b1.png?v=1791666852',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-ridge-set-b2.png?v=1791666852',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-ridge-set-b3.png?v=1791666852',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-ridge-set-b4.png?v=1791666852'
]
},
'cloud-set-milton-hoodie-wide-leg-cotton-pants': {
c: ['بينك مع بنطلون عنابي', 'pink with burgundy pants'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-cloud-set-b0.png?v=1792682490',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-cloud-set-b1.png?v=1792682490',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-cloud-set-b2.png?v=1792682490',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-cloud-set-b3.png?v=1792682490',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-cloud-set-b4.png?v=1792682490'
]
},
'jacket-pants': {
c: ['أحمر مع بنطلون أسود', 'red with black pants'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-storm-set-b0.png?v=1791666852',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-storm-set-b1.png?v=1791666852',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-storm-set-b2.png?v=1791666852',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-storm-set-b3.png?v=1791666851',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy-storm-set-b4.png?v=1791666852'
]
},
'cove-milton-set': {
c: ['رمادي فاتح', 'light gray'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-cove-b0.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-cove-b1.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-cove-b2.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-cove-b3.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-cove-b4.png'
]
},
'dot-gabardine-polka-jacket': {
c: ['أبيض', 'white'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-dot-b0.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-dot-b1.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-dot-b2.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-dot-b3.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-dot-b4.png'
]
},
'flame-gabardine-hooded-zip-jacket': {
c: ['أحمر', 'red'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-flame-b0.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-flame-b1.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-flame-b2.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-flame-b3.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-flame-b4.png'
]
},
'onyx-faux-leather-jacket': {
c: ['أسود', 'black'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-onyx-b0.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-onyx-b1.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-onyx-b2.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-onyx-b3.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-onyx-b4.png'
]
},
'tide-striped-knit-polo-sweater': {
c: ['أكوا', 'aqua'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-tide-b0.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-tide-b1.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-tide-b2.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-tide-b3.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-tide-b4.png'
]
},
'savanna-milton-set': {
c: ['رمادي فاتح', 'light gray'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-savanna-b0.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-savanna-b1.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-savanna-b2.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-savanna-b3.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-savanna-b4.png'
]
},
'willow-ribbed-zip-up-top': {
c: ['أسود', 'black'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-willow-b0.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-willow-b1.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-willow-b2.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-willow-b3.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-willow-b4.png'
]
},
'ember-ribbed-button-top-asymmetric-placket': {
c: ['أبيض', 'white'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ember-b0.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ember-b1.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ember-b2.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ember-b3.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ember-b4.png'
]
},
'ivy-jacquard-cropped-sweater': {
c: ['بترولي', 'teal'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ivy-b0.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ivy-b1.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ivy-b2.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ivy-b3.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-ivy-b4.png'
]
},
'cloud-oversized-milton-hoodie': {
c: ['بينك', 'pink'],
i: [
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-cloud-hoodie-b0.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-cloud-hoodie-b1.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-cloud-hoodie-b2.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-cloud-hoodie-b3.png',
'https://cdn.shopify.com/s/files/1/0791/1902/4365/files/mevy2-cloud-hoodie-b4.png'
]
}
};
/* Anonymous usage counter for the CRM (no name, phone or address).
Contract: /api/mevy on the CRM, see the Mevy tracking spec. Same helper is defined by
snippets/elite-wa-order.liquid and snippets/elite-shipping.liquid; whichever loads first wins. */
window.elTrack = window.elTrack || (function () {
var URL = 'https://elite-crm-kohl.vercel.app/api/mevy';
var pageVid = ''; // used when the browser blocks storage, so those visitors aren't merged into one
function vid() {
try {
var v = localStorage.getItem('el_vid');
if (!v) { v = Date.now().toString(36) + Math.random().toString(36).slice(2, 10); localStorage.setItem('el_vid', v); }
return v;
} catch (e) { return pageVid || (pageVid = Date.now().toString(36) + Math.random().toString(36).slice(2, 10)); }
}
function cartToken() {
var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
if (!m) return '';
try { return decodeURIComponent(m[1]).split('?')[0].slice(0, 64); } catch (e) { return ''; }
}
return function (e, d) {
try {
var body = { e: e, v: vid(), t: cartToken(), l: (document.documentElement.lang || '').slice(0, 2) };
for (var k in d) if (d[k] != null && d[k] !== '') body[k] = d[k];
var s = JSON.stringify(body);
if (navigator.sendBeacon && navigator.sendBeacon(URL, new Blob([s], { type: 'text/plain;charset=UTF-8' }))) return;
fetch(URL, { method: 'POST', body: s, mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' } }).catch(function () {});
} catch (err) {}
};
})();
var NEUTRAL = '#B5AAA2';
var SKIN = '#E2BC9E';
var HAIR = '#3A2820';
var COLORS = {
'red': '#8E3B35', 'أحمر': '#8E3B35', 'احمر': '#8E3B35',
'navy': '#1F2A44', 'كحلي': '#1F2A44',
'black': '#1D1C1C', 'أسود': '#1D1C1C', 'اسود': '#1D1C1C',
'gray': '#8A8A8A', 'grey': '#8A8A8A', 'رمادي': '#8A8A8A',
'blue': '#4A6FA5', 'أزرق': '#4A6FA5', 'ازرق': '#4A6FA5', 'لبني': '#9CB9D8', 'sky': '#9CB9D8',
'dark gray': '#4A4A4A', 'dark grey': '#4A4A4A', 'رمادي غامق': '#4A4A4A', 'رمادي داكن': '#4A4A4A',
'light gray': '#C9C9C9', 'light grey': '#C9C9C9', 'رمادي فاتح': '#C9C9C9',
'burgundy': '#6B2333', 'عنابي': '#6B2333', 'برغندي': '#6B2333',
'brown': '#6B4A35', 'بني': '#6B4A35', 'mocha': '#7A5C4A', 'موكا': '#7A5C4A',
'camel': '#B08A5E', 'جملي': '#B08A5E',
'beige': '#D8C7AE', 'بيج': '#D8C7AE',
'white': '#F4F1EC', 'أبيض': '#F4F1EC', 'ابيض': '#F4F1EC',
'yellow': '#E3C35A', 'أصفر': '#E3C35A', 'اصفر': '#E3C35A',
'aqua': '#7FC4C2', 'أكوا': '#7FC4C2',
'pink': '#E6B7C1', 'بينك': '#E6B7C1', 'وردي': '#E6B7C1',
'olive': '#5B6236', 'زيتي': '#5B6236',
'green': '#3F5E4A', 'أخضر': '#3F5E4A', 'اخضر': '#3F5E4A',
'off white': '#EFEBE3', 'off-white': '#EFEBE3', 'cream': '#EFEBE3', 'أوف وايت': '#EFEBE3',
'charcoal': '#5A5A5C', 'رمادي فحمي': '#5A5A5C',
'lilac': '#B7A3C9', 'موف': '#8E6F9E', 'purple': '#5D4A7A'
};
var T = {
ar: {
pieces: { jacket: 'الجاكت', hoodie: 'الهودي', sweat: 'السويت شيرت', tee: 'التيشيرت', shirt: 'القميص', blouse: 'البلوزة', poncho: 'البونشو', top: 'التوب', pants: 'البنطلون', dress: 'الفستان' },
lengthOf: 'طول {p}',
sleeve: 'الكم',
waist: 'الوسط',
waistElastic: 'بأستك، بيظبط على وسطك',
cm: 'سم', kg: 'كيلو',
start: 'حركي الطول والوزن على مقاسك',
teaserDone: 'طولك {h} ووزنك {w}: {v}',
bands: [
['غالباً هتبقى ضيقة عليكي', 'القطعة دي مناسبة لحد {max} كيلو. ابعتيلنا على واتساب ونقولك الأنسب ليكي.'],
['هتلبس مظبوطة على جسمك', 'قريبة من الجسم من غير ما تضايقك.'],
['هتلبس عليكي مريحة', 'مش ضيقة ولا واسعة زيادة.'],
['هتلبس عليكي أوفر سايز', 'واسعة ومريحة زي ما هي متصممة.'],
['هتبقى واسعة عليكي أوي', 'القطعة معمولة لوزن من {min} لـ {max} كيلو، فهتبقى أوسع من الطبيعي عليكي.']
],
short: ['ضيقة', 'مظبوطة', 'مريحة', 'أوفر سايز', 'واسعة أوي'],
meterEnds: ['واسعة', 'ضيقة'],
at: {
crop: 'فوق الوسط (كروب)', waist: 'على الوسط', belowWaist: 'تحت الوسط بشوية', hip: 'لحد الهانش',
coverHip: 'بيغطي الهانش', thigh: 'لحد نص الفخد', aboveKnee: 'فوق الركبة', knee: 'لحد الركبة',
belowKnee: 'تحت الركبة', calf: 'لحد نص الساق', ankle: 'لحد الكعب', floor: 'لحد الأرض'
},
sleeveLong: 'طويل شوية وبيغطي جزء من الكف',
sleeveOk: 'مظبوط لحد الرسغ',
sleeveShortBy: 'بيوصل قبل الرسغ بـ {n} سم',
sleeveTee: 'كم قصير، البسيه على بادي بكم طويل',
sleevePoncho: 'واسع ومفتوح من الجناب',
pantsShort: 'بيبان فوق الكعب بـ {n} سم',
pantsOk: 'طوله مظبوط لحد الكعب',
pantsCover: 'طويل شوية وبيغطي الجزمة',
pantsLong: 'طويل عليكي {n} سم، البسيه بكعب أو قصريه',
pantsElastic: 'رجله بأستك فهيتلم عند الكعب',
dressFloor: 'هيلمس الأرض، يتلبس بكعب',
mark: '{p}',
heightMark: '{h} سم',
figureLabel: 'رسمة تقريبية للقطعة على طول {h} سم ووزن {w} كيلو',
viewPhoto: 'صورة',
viewDraw: 'رسمة بلونك',
photoAlt: 'Mevy لابسة القطعة على جسم قريب من جسمك',
photoNote: 'صورة لجسم قريب من جسمك على طول {h} سم، واللون {c}.',
notePhoto: 'الصورة تقريبية على حسب طولك ووزنك، وشكل التلبيس بيفرق شوية حسب توزيع الجسم.'
},
en: {
pieces: { jacket: 'Jacket', hoodie: 'Hoodie', sweat: 'Sweatshirt', tee: 'Tee', shirt: 'Shirt', blouse: 'Blouse', poncho: 'Poncho', top: 'Top', pants: 'Pants', dress: 'Dress' },
lengthOf: '{p} length',
sleeve: 'Sleeves',
waist: 'Waist',
waistElastic: 'Elastic, adjusts to your waist',
cm: 'cm', kg: 'kg',
start: 'Move the sliders to your height and weight',
teaserDone: '{h} cm, {w} kg: {v}',
bands: [
['Likely tight on you', 'This piece fits up to {max} kg. Message us on WhatsApp and we will help you choose.'],
['Close fit on you', 'Follows your shape without feeling tight.'],
['Relaxed fit on you', 'Not tight, not too loose.'],
['Oversized fit on you', 'Roomy and easy, the way it was designed.'],
['Very roomy on you', 'Made for {min} to {max} kg, so it will be looser than intended.']
],
short: ['tight', 'close fit', 'relaxed', 'oversized', 'very roomy'],
meterEnds: ['Roomy', 'Tight'],
at: {
crop: 'Above the waist (cropped)', waist: 'At the waist', belowWaist: 'Just below the waist', hip: 'To the hips',
coverHip: 'Covers the hips', thigh: 'Mid-thigh', aboveKnee: 'Above the knee', knee: 'To the knee',
belowKnee: 'Below the knee', calf: 'Mid-calf', ankle: 'To the ankle', floor: 'To the floor'
},
sleeveLong: 'A little long, covers part of the hand',
sleeveOk: 'Ends at the wrist',
sleeveShortBy: 'Ends {n} cm above the wrist',
sleeveTee: 'Short sleeves, wear it over a long-sleeve top',
sleevePoncho: 'Wide and open at the sides',
pantsShort: 'Ends {n} cm above the ankle',
pantsOk: 'Ends right at the ankle',
pantsCover: 'A little long, covers your shoes',
pantsLong: '{n} cm long on you, wear heels or hem it',
pantsElastic: 'Elastic hem gathers at the ankle',
dressFloor: 'Touches the floor, best with heels',
mark: '{p}',
heightMark: '{h} cm',
figureLabel: 'Approximate drawing of the piece at {h} cm and {w} kg',
viewPhoto: 'Photo',
viewDraw: 'Drawing in your colour',
photoAlt: 'Mevy wearing the piece on a body close to yours',
photoNote: 'A body close to yours at {h} cm, shown in {c}.',
notePhoto: 'The photo is approximate. The fit also depends on how weight is distributed.'
}
};
function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
function lerp(a, b, t) { return a + (b - a) * t; }
function fmt(s, o) { return s.replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
function r1(n) { return Math.round(n * 10) / 10; }
/* ---------- colour ---------- */
function hexToRgb(h) {
h = h.replace('#', '');
if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
var n = parseInt(h, 16);
return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}
function rgbToHex(c) {
return '#' + c.map(function (v) { return ('0' + Math.round(clamp(v, 0, 255)).toString(16)).slice(-2); }).join('');
}
function parseColor(c) {
if (!c) return null;
if (c.charAt(0) === '#') return c;
var m = c.match(/\d+(\.\d+)?/g);
if (m && m.length >= 3) return rgbToHex([+m[0], +m[1], +m[2]]);
return null;
}
function shade(hex, p) {
var c = hexToRgb(hex), t = p < 0 ? 0 : 255, a = Math.abs(p);
return rgbToHex(c.map(function (v) { return v + (t - v) * a; }));
}
function luma(hex) {
var c = hexToRgb(hex);
return (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) / 255;
}
function colorFromName(name) {
if (!name) return null;
var n = String(name).toLowerCase().replace(/[_]+/g, ' ').trim();
if (COLORS[n]) return COLORS[n];
var best = null, len = 0;
Object.keys(COLORS).forEach(function (k) {
var re = new RegExp('(^|[^a-z\u0600-\u06ff])' + k.replace(/[-]/g, '[- ]') + '($|[^a-z\u0600-\u06ff])');
if (k.length > len && re.test(n)) { best = COLORS[k]; len = k.length; }
});
return best;
}
/* ---------- what the product is ---------- */
function profile(d) {
var h = ((d.handle || '') + ' ' + (d.title || '')).toLowerCase();
var type = d.type || '';
var tags = (d.tags || []).map(function (t) { return String(t).toLowerCase(); });
var has = function (t) { return tags.indexOf(t) > -1; };
var max = 85;
tags.forEach(function (t) { var fm = /^fit-(\d{2,3})$/.exec(t); if (fm) max = +fm[1]; });
var pattern = /stripe|مقلم|مقلّم/.test(h) ? 'stripe' : /zigzag|زجزاج/.test(h) ? 'zigzag' : null;
var crop = /crop|كروب/.test(h);
function topOf(src, inSet) {
if (/hood|هودي/.test(src)) return { style: 'hoodie', len: crop ? 44 : 66, sleeve: 58 };
if (/jacket|coat|blazer|جاكت|جاكيت|بليزر/.test(src) || has('size-jacket') || type === 'Jackets') {
return { style: 'jacket', len: has('size-suit') ? 68 : has('size-jacket') ? 60 : crop ? 48 : 62, sleeve: 58 };
}
if (/sweat|سويت/.test(src)) return { style: 'sweat', len: has('size-tshirt') ? 72 : 66, sleeve: 58 };
if (/(^|[^a-z])tee([^a-z]|$)|t-shirt|tshirt|تيشيرت|تي شيرت/.test(src)) return { style: 'tee', len: has('size-tshirt') ? 72 : 68, sleeve: 24 };
if (/poncho|pancho|cape|بونشو/.test(src)) return { style: 'poncho', len: 66, sleeve: 0 };
if (/shirt|قميص/.test(src)) return { style: 'shirt', len: inSet ? 68 : 74, sleeve: 58 };
if (/blouse|بلوز/.test(src)) return { style: 'blouse', len: has('size-tshirt') ? 72 : 64, sleeve: 58 };
return { style: inSet ? 'shirt' : 'top', len: inSet ? 68 : 66, sleeve: 58 };
}
function pantsOf(src) {
return { style: /haven|balloon|jogger|هيفن|بالون|جوجر/.test(src) ? 'balloon' : 'wide', len: 105 };
}
var p = { max: max, min: max - 30, pattern: pattern };
if (has('size-dress') || type === 'Dresses' || /dress|abaya|فستان|عباية|إسدال|اسدال/.test(h)) {
p.kind = 'dress';
p.dress = { len: 135, sleeve: 58 };
} else if (type === 'Sets' || has('size-suit') || (has('size-jacket') && has('size-pants'))) {
p.kind = 'set';
p.top = topOf(h, true);
p.pants = pantsOf(h);
} else if (type === 'Pants' || has('size-pants') || /pant|trouser|jeans|بنطلون/.test(h)) {
p.kind = 'pants';
p.pants = pantsOf(h);
} else if (type === 'Jackets' || type === 'Tops' || has('size-jacket') || has('size-tshirt')) {
p.kind = 'top';
p.top = topOf(h, false);
} else {
p.kind = null;
}
var sp = SPECS[String(d.handle || '').toLowerCase()];
if (sp) {
if (sp.max) { p.max = sp.max; p.min = sp.max - 30; }
if (sp.min) p.min = sp.min;
if (sp.pants && p.pants) for (var sk in sp.pants) p.pants[sk] = sp.pants[sk];
if (sp.top && p.top) for (var tk in sp.top) p.top[tk] = sp.top[tk];
}
return p;
}
/* Which colour options paint which piece. */
function colorGroups(d) {
var groups = [];
(d.options || []).forEach(function (o) {
var n = String(o.name || '').toLowerCase();
if (!/colou?r|لون/.test(n)) return;
var role = /jacket|جاكت|hood|هودي|top|توب|blouse|بلوز|shirt|قميص/.test(n) ? 'top'
: /pant|بنطلون|trouser/.test(n) ? 'pants' : 'all';
groups.push({
name: o.name,
position: o.position,
role: role,
values: (o.values || []).map(function (v) {
return { name: v.n, hex: parseColor(v.sw) || colorFromName(v.n) || NEUTRAL, selected: !!v.sel };
})
});
});
return groups;
}
function fallbackColor(d) {
var parts = String(d.title || '').split(' — ');
var c = parts.length > 1 ? colorFromName(parts[parts.length - 1]) : null;
if (!c) c = colorFromName(String(d.handle || '').replace(/[-_]+/g, ' '));
return c || NEUTRAL;
}
/* ---------- body ---------- */
function sFor(w, h) { return Math.sqrt((w / h) / (60 / 160)); }
function body(H, W) {
var s = clamp(sFor(W, H), 0.78, 1.5);
var frame = H / REF_H;
var b = {
H: H, W: W, s: s,
chin: 0.872 * H, hps: 0.835 * H, sh: 0.815 * H, bust: 0.725 * H, waist: 0.625 * H,
hip: 0.525 * H, crotch: 0.465 * H, thigh: 0.39 * H, knee: 0.285 * H, calf: 0.17 * H, ankle: 0.045 * H,
wrist: 0.485 * H, arm: 0.335 * H,
shW: 36.5 * frame * (0.86 + 0.14 * s),
bustW: 0.345 * 91 * s,
waistW: 0.33 * 74 * Math.pow(s, 1.3),
hipW: 0.36 * 99 * Math.pow(s, 0.92)
};
b.legC = b.hipW / 4 + 1.2;
return b;
}
/* Body width (both legs together below the crotch) at a height above the floor. */
function widthAt(b, y) {
var pts = [
[b.sh, b.shW * 0.9], [b.bust, b.bustW], [b.waist, b.waistW], [b.hip, b.hipW], [b.crotch, b.hipW * 0.97],
[b.thigh, b.hipW * 0.9], [b.knee, b.hipW * 0.66], [b.calf, b.hipW * 0.6], [0, b.hipW * 0.5]
];
if (y >= pts[0][0]) return pts[0][1];
for (var i = 0; i < pts.length - 1; i++) {
if (y <= pts[i][0] && y >= pts[i + 1][0]) {
var t = (pts[i][0] - y) / (pts[i][0] - pts[i + 1][0]);
return lerp(pts[i][1], pts[i + 1][1], t);
}
}
return pts[pts.length - 1][1];
}
/* ---------- fit ---------- */
function fit(H, W, p) {
var weq = W * REF_H / H;
var t = [p.max - 30, p.max - 19.5, p.max - 9.5, p.max + 0.5];
var band = weq > t[3] ? 0 : weq > t[2] ? 1 : weq > t[1] ? 2 : weq >= t[0] ? 3 : 4;
var meter = clamp((weq - (t[0] - 10)) / (t[3] - t[0] + 20), 0, 1);
return { band: band, meter: meter, weq: weq };
}
function garment(p) {
var sMax = sFor(p.max + 1, REF_H);
return {
chest: 0.345 * 91 * sMax + 0.5,
hip: 0.36 * 99 * Math.pow(sMax, 0.92) + 0.5,
shBase: 36.5 * (0.86 + 0.14 * sMax)
};
}
/* ---------- svg helpers ---------- */
function X(x) { return r1(x); }
function Y(h) { return r1(FLOOR - h); }
/* Smooth closed path through points [x, h, corner]. */
function pathOf(pts, closed) {
var n = pts.length;
var P = pts.map(function (p) { return [p[0], FLOOR - p[1], !!p[2]]; });
var d = 'M' + r1(P[0][0]) + ' ' + r1(P[0][1]);
var k = 1;
var last = closed ? n : n - 1;
for (var i = 0; i < last; i++) {
var p0 = P[(i - 1 + n) % n], p1 = P[i], p2 = P[(i + 1) % n], p3 = P[(i + 2) % n];
if (!closed) { if (i === 0) p0 = p1; if (i + 2 >= n) p3 = p2; }
var c1 = p1[2] ? [p1[0], p1[1]] : [p1[0] + (p2[0] - p0[0]) / 6 * k, p1[1] + (p2[1] - p0[1]) / 6 * k];
var c2 = p2[2] ? [p2[0], p2[1]] : [p2[0] - (p3[0] - p1[0]) / 6 * k, p2[1] - (p3[1] - p1[1]) / 6 * k];
d += 'C' + r1(c1[0]) + ' ' + r1(c1[1]) + ' ' + r1(c2[0]) + ' ' + r1(c2[1]) + ' ' + r1(p2[0]) + ' ' + r1(p2[1]);
}
return d + (closed ? 'Z' : '');
}
/* Left-half outline (x = half width, top to bottom) mirrored into a closed shape. */
function sym(half) {
var left = half.map(function (p) { return [-p[0], p[1], p[2]]; });
var right = [];
for (var i = half.length - 1; i >= 0; i--) {
if ((i === 0 || i === half.length - 1) && half[i][0] === 0) continue;
right.push([half[i][0], half[i][1], half[i][2]]);
}
return pathOf(left.concat(right), true);
}
function mirrorPts(pts) { return pts.map(function (p) { return [-p[0], p[1], p[2]]; }); }
function el(tag, attrs) {
var s = '<' + tag;
for (var k in attrs) if (attrs[k] != null) s += ' ' + k + '="' + attrs[k] + '"';
return s + '/>';
}
function piece(d, fill, id, extra) {
var stroke = shade(fill.base, -0.28);
return el('path', { d: d, fill: fill.paint, stroke: stroke, 'stroke-width': 0.3, 'stroke-linejoin': 'round' }) +
el('path', { d: d, fill: 'url(#' + id + '-sh)', 'pointer-events': 'none' }) + (extra || '');
}
function line(pts, color, w, op, dash) {
return el('path', { d: pathOf(pts, false), fill: 'none', stroke: color, 'stroke-width': w || 0.3, 'stroke-linecap': 'round', opacity: op == null ? 1 : op, 'stroke-dasharray': dash });
}
/* ---------- drawing ---------- */
function draw(state, cfg, opts) {
var p = cfg.p, b = body(state.h, state.w), f = fit(state.h, state.w, p), G = garment(p);
var uid = opts.uid;
var topHex = state.colors.top, pantsHex = state.colors.pants;
var out = { defs: '', back: '', mid: '', arms: '', front: '', marks: [] };
var tr = cfg.t;
function fillFor(hex, key) {
var paint = hex;
if (p.pattern && (key === 'top' || key === 'dress' || (key === 'pants' && p.kind === 'set'))) {
var pid = uid + '-pat-' + key, dk = shade(hex, luma(hex) > 0.5 ? -0.22 : 0.3);
if (p.pattern === 'stripe') {
out.defs += '<pattern id="' + pid + '" patternUnits="userSpaceOnUse" width="2.4" height="4">' +
el('rect', { width: 2.4, height: 4, fill: hex }) + el('rect', { width: 0.55, height: 4, fill: dk }) + '</pattern>';
} else {
out.defs += '<pattern id="' + pid + '" patternUnits="userSpaceOnUse" width="6" height="5">' +
el('rect', { width: 6, height: 5, fill: hex }) +
el('path', { d: 'M0 3.5L1.5 1.5L3 3.5L4.5 1.5L6 3.5', fill: 'none', stroke: dk, 'stroke-width': 0.6 }) + '</pattern>';
}
paint = 'url(#' + pid + ')';
}
var sid = uid + '-' + key;
out.defs += '<linearGradient id="' + sid + '-sh" x1="0" x2="1" y1="0" y2="0">' +
'<stop offset="0" stop-color="#000" stop-opacity=".2"/><stop offset=".2" stop-color="#000" stop-opacity="0"/>' +
'<stop offset=".8" stop-color="#000" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".2"/></linearGradient>';
return { base: hex, paint: paint, id: sid };
}
var hasPants = p.kind === 'pants' || p.kind === 'set';
var hasTop = p.kind === 'top' || p.kind === 'set';
var isDress = p.kind === 'dress';
var mainHex = isDress ? topHex : hasTop ? topHex : pantsHex;
var light = luma(mainHex) > 0.62;
var baseTop = '#ECE5DC';
var basePants = luma(topHex) > 0.55 ? '#3A3536' : '#D6CCC1';
var shoe = '#F6F3EF';
/* top piece geometry first: arms are placed outside it */
var top = null;
if (hasTop) {
var tp = p.top, boxy = /jacket|tee|sweat|hoodie|poncho/.test(tp.style);
var chestW = Math.max(G.chest * (tp.style === 'blouse' || tp.style === 'top' ? 0.95 : 1), b.bustW + 1.2);
var hemH = b.hps - tp.len;
var waistG = boxy ? Math.max(chestW * 0.98, b.waistW + 1.2) : Math.max(lerp(chestW, b.waistW + 2.5, 0.45), b.waistW + 1.2);
var hemW = Math.max(boxy ? chestW : chestW * 0.97, widthAt(b, hemH) + 1.5);
if (tp.style === 'hoodie' && tp.len <= 55) hemW = Math.max(chestW * 0.93, widthAt(b, hemH) + 1);
if (tp.style === 'poncho') hemW = chestW * 1.6;
var drop = { jacket: 4, hoodie: 5, sweat: 5, tee: 5, poncho: 0, shirt: 2, blouse: 1, top: 2 }[tp.style];
var gSh = Math.max(b.shW + 1, G.shBase + drop);
top = { tp: tp, chestW: chestW, hemH: hemH, waistG: waistG, hemW: hemW, gSh: gSh, boxy: boxy };
}
var dress = null;
if (isDress) {
var dl = p.dress;
var dHem = b.hps - dl.len;
var dBust = Math.max(G.chest * 0.97, b.bustW + 1.5);
dress = { len: dl.len, hemH: dHem, bustW: dBust, hemW: 30 + dl.len * 0.25, gSh: b.shW + 1.5 };
}
var bodyHalf = Math.max(b.hipW / 2, top ? Math.max(top.hemW, top.chestW) / 2 : 0, dress ? dress.bustW / 2 + 1 : 0);
if (top && top.tp.style === 'poncho') bodyHalf = Math.max(b.hipW / 2, top.chestW / 2);
if (hasPants) bodyHalf = Math.max(bodyHalf, Math.max(G.hip, b.hipW + 2) / 2 + 0.5);
var S = [-(b.shW / 2 - 1.6), b.sh - 1.4];
var Wr = [-(bodyHalf + 2.6), b.wrist];
var ax = Wr[0] - S[0], ay = Wr[1] - S[1], aL = Math.sqrt(ax * ax + ay * ay);
var u = [ax / aL, ay / aL], nrm = [u[1], -u[0]];
if (nrm[0] > 0) nrm = [-nrm[0], -nrm[1]];
function along(t) { return [S[0] + ax * t, S[1] + ay * t]; }
/* shadow + shoes */
out.back += el('ellipse', { cx: 0, cy: Y(-0.6), rx: 24, ry: 2.2, fill: '#000', opacity: 0.07 });
[-1, 1].forEach(function (sgn) {
var cx = sgn * b.legC;
out.back += el('path', { d: 'M' + X(cx - 4.2) + ' ' + Y(0) + 'C' + X(cx - 4.6) + ' ' + Y(3.4) + ' ' + X(cx + 4.6) + ' ' + Y(3.4) + ' ' + X(cx + 4.2) + ' ' + Y(0) + 'Z', fill: shoe, stroke: '#CFC6BD', 'stroke-width': 0.3 });
});
/* base layer: long-sleeve high-neck top (always), wide pants when the piece has no bottom */
var baseTorso = sym([[6, b.hps + 0.6, 1], [b.shW / 2, b.sh - 0.6], [b.bustW / 2 + 0.6, b.bust], [b.waistW / 2 + 1.2, b.waist], [b.hipW / 2 + 1.2, b.hip], [b.hipW / 2 + 1.2, b.crotch + 3, 1], [0, b.crotch + 2.4, 1]]);
if (!hasPants && !isDress) {
var bpHip = b.hipW + 4, bpHem = Math.max(b.legC + 6.5, bpHip / 2 + 1.5);
out.mid += el('path', { d: sym([[0, b.waist + 1, 1], [b.waistW / 2 + 1.5, b.waist + 1, 1], [bpHip / 2, b.hip], [bpHem, 1.2, 1], [0.8, 1.2, 1], [0, b.crotch - 2, 1]]), fill: basePants, stroke: shade(basePants, -0.25), 'stroke-width': 0.3 });
}
var fb = fillFor(baseTop, 'base');
out.mid += piece(baseTorso, fb, fb.id);
/* hands, then base sleeves */
var hand = function (sgn) {
var a = along(1.0), e = along(1.0 + 15 / aL);
var cx = (a[0] + e[0]) / 2 * -sgn, cy = (a[1] + e[1]) / 2;
var ang = Math.atan2(-ax, -ay) * 180 / Math.PI * -sgn;
return el('ellipse', { cx: X(cx), cy: Y(cy), rx: 3.4, ry: 8.2, fill: SKIN, transform: 'rotate(' + r1(ang) + ' ' + X(cx) + ' ' + Y(cy) + ')' });
};
function sleevePath(sgn, t0, t1, w0, w1, topPt) {
var a = along(t0), c = along(t1);
var o0 = topPt || [a[0] + nrm[0] * w0 / 2, a[1] + nrm[1] * w0 / 2];
var i0 = [a[0] - nrm[0] * w0 / 2 + 1.5, a[1] - nrm[1] * w0 / 2 - 3];
var o1 = [c[0] + nrm[0] * w1 / 2, c[1] + nrm[1] * w1 / 2];
var i1 = [c[0] - nrm[0] * w1 / 2, c[1] - nrm[1] * w1 / 2];
var mid = along((t0 + t1) / 2);
var om = [mid[0] + nrm[0] * (w0 + w1) / 4 + nrm[0] * 0.4, mid[1] + nrm[1] * (w0 + w1) / 4];
var pts = [[o0[0], o0[1]], [om[0], om[1]], [o1[0], o1[1], 1], [i1[0], i1[1], 1], [i0[0], i0[1]]];
if (sgn > 0) pts = mirrorPts(pts);
return { d: pathOf(pts, true), cuff: [o1, i1] };
}
var armsHidden = top && top.tp.style === 'poncho';
[-1, 1].forEach(function (sgn) {
out.arms += hand(sgn);
if (!armsHidden) {
var bs = sleevePath(sgn, 0, 1.0, 9, 6.6);
out.arms += piece(bs.d, fb, fb.id);
}
});
/* pants */
if (hasPants) {
var pp = p.pants, fp = fillFor(pantsHex, 'pants');
var waistH = b.waist + 1, pHem = waistH - pp.len;
var hipG = Math.max(G.hip, b.hipW + 2), ww = b.waistW + 2.6;
var crotchH = b.crotch - 2.5, he = Math.max(pHem, 0.6);
var pd, details = '', pantsHemAt = pHem;
var dk = shade(pantsHex, luma(pantsHex) > 0.4 ? -0.22 : 0.22);
if (pp.style === 'balloon') {
var cuffH = Math.max(pHem, 0) + 0.6, cuffH2 = Math.max(cuffH, b.ankle + 0.6);
var lc = b.legC, outerMax = hipG / 2 + 4.2;
pd = sym([[0, waistH, 1], [ww / 2, waistH, 1], [hipG / 2 + 0.6, b.hip], [outerMax, b.knee + 6], [lc + 7, cuffH2 + 3], [lc + 6.2, cuffH2 - 0.4, 1], [Math.max(lc - 6.2, 1), cuffH2 - 0.4, 1], [Math.max(lc - 7.2, 0.9), cuffH2 + 4], [1.2, b.knee + 4], [0, crotchH, 1]]);
details += line([[-(lc + 6.2), cuffH2 + 2.4], [-(lc - 6.2), cuffH2 + 2.4]], dk, 0.3, 0.7) + line([[lc + 6.2, cuffH2 + 2.4], [lc - 6.2, cuffH2 + 2.4]], dk, 0.3, 0.7);
var extra = Math.max(0, -pHem);
for (var fi = 0; fi < 2 + (extra > 4 ? 1 : 0); fi++) {
var fy = cuffH2 + 5 + fi * 3.4;
[-1, 1].forEach(function (sg) { details += line([[sg * (lc + 6), fy], [sg * lc, fy + 1.2], [sg * (lc - 5.5), fy]], dk, 0.3, 0.45); });
}
pantsHemAt = cuffH2;
} else {
var pool = pHem < 0 ? Math.min(3, -pHem * 0.4) : 0;
var outerHem = Math.max(hipG / 2 + 2.2, b.legC + 8) + pool;
pd = sym([[0, waistH, 1], [ww / 2, waistH, 1], [hipG / 2, b.hip], [hipG / 2 + 1, b.knee], [outerHem, he, 1], [0.9, he, 1], [0.9, b.knee - 6], [0, crotchH, 1]]);
[-1, 1].forEach(function (sg) {
details += line([[sg * (hipG / 4 + 1), b.hip - 8], [sg * (outerHem / 2 + 1.5), he + 6]], dk, 0.3, 0.35);
if (pool > 0.5) details += line([[sg * 2.5, he + 3], [sg * (outerHem / 2), he + 1.6], [sg * (outerHem - 2), he + 3]], dk, 0.3, 0.45);
});
pantsHemAt = pHem;
}
for (var gi = -3; gi <= 3; gi++) details += line([[gi * ww / 8, waistH - 0.4], [gi * ww / 8 + 0.2, waistH - 3.6]], dk, 0.25, 0.45);
details += line([[-ww / 2, waistH - 4], [ww / 2, waistH - 4]], dk, 0.3, 0.6);
out.mid += piece(pd, fp, fp.id, details);
var pantsMsg;
if (pp.style === 'balloon') pantsMsg = tr.pantsElastic;
else if (pHem > 8) pantsMsg = fmt(tr.pantsShort, { n: Math.round(pHem) });
else if (pHem >= 0) pantsMsg = tr.pantsOk;
else if (pHem >= -6) pantsMsg = tr.pantsCover;
else pantsMsg = fmt(tr.pantsLong, { n: Math.round(-pHem) });
out.pantsFact = [fmt(tr.lengthOf, { p: tr.pieces.pants }), pantsMsg];
out.marks.push({ h: Math.max(pantsHemAt, 0), label: tr.pieces.pants, key: 'pants' });
}
/* dress */
if (dress) {
var fd = fillFor(topHex, 'dress');
var dPool = dress.hemH < 0 ? Math.min(4, -dress.hemH * 0.5) : 0;
var dHemY = Math.max(dress.hemH, 0.4);
var dHemW = dress.hemW + dPool * 2;
var dWaist = Math.max(b.waistW + 5, dress.bustW * 0.9);
var dd = sym([[6.4, b.hps + 0.4, 1], [dress.gSh / 2, b.sh - 0.8], [dress.bustW / 2, b.bust], [dWaist / 2, b.waist], [Math.max(b.hipW + 6, dWaist + 4) / 2, b.hip], [dHemW / 2, dHemY, 1], [0, dHemY - 0.6, 1]]);
var ddet = '';
var ddk = shade(topHex, luma(topHex) > 0.4 ? -0.2 : 0.22);
[-1, 1].forEach(function (sg) {
ddet += line([[sg * dress.bustW / 4, b.waist], [sg * dHemW / 5, dHemY + 1]], ddk, 0.3, 0.35);
ddet += line([[sg * (dress.bustW / 2 - 2), b.hip], [sg * (dHemW / 2.6), dHemY + 1]], ddk, 0.3, 0.3);
});
out.mid += piece(dd, fd, fd.id, ddet);
out.marks.push({ h: dHemY, label: tr.pieces.dress, key: 'dress' });
}
/* top piece */
if (top) {
var ft = fillFor(topHex, 'top');
var tp2 = top.tp;
var tdk = shade(topHex, luma(topHex) > 0.4 ? -0.24 : 0.24);
var shoulderPt = [top.gSh / 2, b.sh - 0.8 - Math.max(0, (top.gSh - b.shW) / 2) * 0.35];
var outline;
if (tp2.style === 'poncho') {
outline = sym([[6.4, b.hps + 0.4, 1], [b.shW / 2 + 1.5, b.sh - 1.2], [top.chestW / 2 + 3, b.bust - 2], [top.hemW / 2, top.hemH, 1], [0, top.hemH - 1.5, 1]]);
} else {
outline = sym([[6.4, b.hps + 0.4, 1], [shoulderPt[0], shoulderPt[1]], [top.chestW / 2, b.bust + 1.2], [top.waistG / 2, b.waist], [top.hemW / 2, top.hemH, 1], [0, top.hemH - 0.3, 1]]);
}
var tdet = '';
if (/jacket|hoodie/.test(tp2.style)) tdet += line([[0, b.hps], [0, top.hemH]], tdk, 0.35, 0.8);
if (tp2.style === 'shirt') {
tdet += line([[0.9, b.hps], [0.9, top.hemH]], tdk, 0.25, 0.6);
for (var bi = 0; bi < 5; bi++) tdet += el('circle', { cx: 0, cy: Y(lerp(b.bust - 2, top.hemH + 5, bi / 4)), r: 0.45, fill: tdk });
}
if (/hoodie|sweat/.test(tp2.style)) tdet += line([[-top.hemW / 2, top.hemH + 3.2], [top.hemW / 2, top.hemH + 3.2]], tdk, 0.3, 0.6);
if (tp2.style === 'jacket') {
[-1, 1].forEach(function (sg) { tdet += line([[sg * (top.waistG / 2 - 7.5), b.waist - 1], [sg * (top.waistG / 2 - 4.5), b.waist - 7.5]], tdk, 0.35, 0.7); });
}
if (f.band >= 3 && top.boxy) {
[-1, 1].forEach(function (sg) { tdet += line([[sg * top.chestW / 4, b.bust - 4], [sg * (top.chestW / 4 + 0.6), b.waist - 2], [sg * top.hemW / 4, top.hemH + 2]], tdk, 0.3, 0.3); });
}
if (f.band === 0) {
[-1, 1].forEach(function (sg) { tdet += line([[sg * (b.bustW / 2 - 7), b.bust - 1], [sg * (b.bustW / 2 - 3.5), b.bust - 2.2], [sg * (b.bustW / 2 - 0.5), b.bust - 1.4]], tdk, 0.3, 0.45); });
}
out.front += piece(outline, ft, ft.id, tdet);
/* garment sleeves */
if (!armsHidden) {
var dropDown = Math.max(0, (top.gSh - b.shW) / 2) * 1.1;
var sEnd = clamp((dropDown + tp2.sleeve) / aL, 0.2, 1 + 7 / aL);
var w0 = top.boxy ? 13 : 11, w1 = tp2.sleeve < 35 ? 12.5 : top.boxy ? 9.6 : 8.6;
[-1, 1].forEach(function (sgn) {
var sp = sleevePath(sgn, 0, sEnd, w0, w1, [-shoulderPt[0], shoulderPt[1]]);
var cuff = '';
if (/jacket|sweat|hoodie/.test(tp2.style)) {
var cA = along(sEnd - 3.2 / aL);
var c1 = [cA[0] + nrm[0] * w1 / 2, cA[1] + nrm[1] * w1 / 2], c2 = [cA[0] - nrm[0] * w1 / 2, cA[1] - nrm[1] * w1 / 2];
cuff = line([[c1[0] * sgn * -1, c1[1]], [c2[0] * sgn * -1, c2[1]]], tdk, 0.3, 0.6);
}
out.front += piece(sp.d, ft, ft.id, cuff);
});
var reach = dropDown + tp2.sleeve - b.arm;
out.sleeveFact = [tr.sleeve, tp2.sleeve < 35 ? tr.sleeveTee : reach > 3 ? tr.sleeveLong : reach >= -3 ? tr.sleeveOk : fmt(tr.sleeveShortBy, { n: Math.round(-reach) })];
} else {
out.sleeveFact = [tr.sleeve, tr.sleevePoncho];
}
out.topFact = [fmt(tr.lengthOf, { p: tr.pieces[tp2.style] }), whereIs(b, top.hemH, tr)];
out.marks.push({ h: top.hemH, label: tr.pieces[tp2.style], key: 'top' });
}
if (dress) {
var dReach = Math.max(0, (dress.gSh - b.shW) / 2) + p.dress.sleeve - b.arm;
var dEnd = clamp((Math.max(0, (dress.gSh - b.shW) / 2) + p.dress.sleeve) / aL, 0.2, 1 + 7 / aL);
var fd2 = { base: topHex, paint: p.pattern ? 'url(#' + uid + '-pat-dress)' : topHex, id: uid + '-dress' };
[-1, 1].forEach(function (sgn) {
var sp = sleevePath(sgn, 0, dEnd, 11, 8.6, [-(dress.gSh / 2), b.sh - 0.8]);
out.front += piece(sp.d, fd2, fd2.id);
});
out.topFact = [fmt(tr.lengthOf, { p: tr.pieces.dress }), dress.hemH < -1 ? tr.dressFloor : whereIs(b, dress.hemH, tr)];
out.sleeveFact = [tr.sleeve, dReach > 3 ? tr.sleeveLong : dReach >= -3 ? tr.sleeveOk : fmt(tr.sleeveShortBy, { n: Math.round(-dReach) })];
}
/* head: face, neck and long hair (back layer behind the clothes, front locks over the shoulders) */
var H = b.H, Rx = 0.037 * H, Ry = 0.056 * H, fcy = b.chin + 0.058 * H, crown = fcy + Ry + 1.3;
var hair = HAIR, hairHi = shade(HAIR, 0.32), hairDk = shade(HAIR, -0.35);
var nape = Math.max(b.shW * 0.34, Rx + 6);
out.defs += '<linearGradient id="' + uid + '-hair" x1="0" x2="1" y1="0" y2="0"><stop offset="0" stop-color="' + hairDk + '"/><stop offset=".5" stop-color="' + hair + '"/><stop offset="1" stop-color="' + hairDk + '"/></linearGradient>';
out.back += el('path', { d: sym([[0, crown + 0.4, 1], [Rx + 1.9, fcy + Ry * 0.55], [Rx + 2.6, fcy - Ry * 0.25], [Rx + 3.4, b.chin - 1.5], [nape, b.sh - 2], [nape + 0.6, b.bust + 5], [nape - 2.2, b.bust + 2.6, 1], [0, b.bust + 3.4, 1]]), fill: 'url(#' + uid + '-hair)', stroke: hairDk, 'stroke-width': 0.3 });
out.back += el('path', { d: sym([[2.6, b.chin + 1, 1], [2.9, b.hps - 1, 1], [0, b.hps - 1.6, 1]]), fill: SKIN, stroke: shade(SKIN, -0.18), 'stroke-width': 0.25 });
out.back += el('ellipse', { cx: 0, cy: Y(b.chin + 0.4), rx: 2.9, ry: 1.3, fill: shade(SKIN, -0.16), opacity: 0.55 });
out.front += el('ellipse', { cx: 0, cy: Y(fcy), rx: r1(Rx), ry: r1(Ry), fill: SKIN, stroke: shade(SKIN, -0.16), 'stroke-width': 0.25 });
[-1, 1].forEach(function (sg) {
var ex = sg * Rx * 0.42, ey = fcy + Ry * 0.05;
out.front += line([[ex - sg * 1.5, ey + 1.9], [ex, ey + 2.5], [ex + sg * 1.4, ey + 2.1]], hairDk, 0.35, 0.75);
out.front += line([[ex - sg * 1.2, ey + 0.1], [ex, ey - 0.5], [ex + sg * 1.2, ey + 0.1]], '#4A3530', 0.35, 0.85);
out.front += el('ellipse', { cx: X(sg * Rx * 0.5), cy: Y(fcy - Ry * 0.32), rx: 1.4, ry: 0.8, fill: '#D9937F', opacity: 0.22 });
});
out.front += line([[-0.35, fcy - Ry * 0.12], [0.2, fcy - Ry * 0.2]], shade(SKIN, -0.22), 0.3, 0.6);
out.front += el('path', { d: 'M' + X(-1.5) + ' ' + Y(fcy - Ry * 0.48) + 'Q' + X(0) + ' ' + Y(fcy - Ry * 0.62) + ' ' + X(1.5) + ' ' + Y(fcy - Ry * 0.48) + 'Q' + X(0) + ' ' + Y(fcy - Ry * 0.42) + ' ' + X(-1.5) + ' ' + Y(fcy - Ry * 0.48) + 'Z', fill: '#B86A62', opacity: 0.8 });
var lock = function (sg) {
var pts = [[Rx + 1.4, fcy + Ry * 0.3], [Rx + 2.6, b.chin - 0.5], [Rx + 5, b.hps - 1], [Rx + 6.6, b.sh - 4], [Rx + 6.1, b.bust + 2.4, 1], [Rx + 3.6, b.bust + 5], [Rx + 3.1, b.sh - 2.2], [Rx + 1.7, b.hps + 0.2], [Rx + 0.1, b.chin + 2], [Rx - 0.6, fcy - Ry * 0.1]];
return pathOf(pts.map(function (q) { return [sg * q[0], q[1], q[2]]; }), true);
};
[-1, 1].forEach(function (sg) {
out.front += el('path', { d: lock(sg), fill: 'url(#' + uid + '-hair)', stroke: hairDk, 'stroke-width': 0.3 });
out.front += line([[sg * (Rx + 1.6), b.chin], [sg * (Rx + 4.6), b.sh - 1], [sg * (Rx + 5), b.bust + 4]], hairHi, 0.3, 0.5);
});
out.front += el('path', { d: pathOf([[-(Rx + 1.1), fcy - 1.2], [-(Rx + 1.2), fcy + Ry * 0.6], [-Rx * 0.35, crown], [Rx * 0.6, crown - 0.3], [Rx + 1.1, fcy + Ry * 0.55], [Rx + 0.9, fcy - 1.4, 1], [Rx * 0.6, fcy + Ry * 0.5], [Rx * 0.05, fcy + Ry * 0.74], [-Rx * 0.55, fcy + Ry * 0.52], [-Rx * 0.9, fcy + Ry * 0.1]], true), fill: hair, stroke: hairDk, 'stroke-width': 0.3 });
out.front += line([[-Rx * 0.2, crown - 0.6], [Rx * 0.05, fcy + Ry * 0.74]], hairDk, 0.25, 0.6) + line([[Rx * 0.5, crown - 0.8], [Rx + 0.4, fcy + Ry * 0.3]], hairHi, 0.3, 0.5);
out.fit = f;
out.b = b;
out.svg = '<defs>' + out.defs + '</defs>' + out.back + out.mid + out.arms + out.front;
return out;
}
function whereIs(b, y, tr) {
var a = tr.at;
if (y >= b.waist + 3) return a.crop;
if (y >= b.waist - 3) return a.waist;
if (y >= b.hip + 3) return a.belowWaist;
if (y >= b.hip - 3) return a.hip;
if (y >= b.crotch - 4) return a.coverHip;
if (y >= b.thigh - 4) return a.thigh;
if (y >= b.knee + 4) return a.aboveKnee;
if (y >= b.knee - 4) return a.knee;
if (y >= b.calf) return a.belowKnee;
if (y >= b.ankle + 6) return a.calf;
if (y >= -1) return a.ankle;
return a.floor;
}
/* ruler + height marker + hem lines (svg part) */
function guides(b, marks) {
var s = '', rx = 41;
s += el('line', { x1: rx, y1: Y(0), x2: rx, y2: Y(200), stroke: '#D3CAC2', 'stroke-width': 0.3 });
for (var h = 0; h <= 200; h += 10) {
var big = h % 50 === 0;
s += el('line', { x1: rx, y1: Y(h), x2: rx - (big ? 3 : 1.6), y2: Y(h), stroke: '#C4BAB1', 'stroke-width': big ? 0.4 : 0.3 });
}
s += el('line', { x1: -6, y1: Y(b.H + 1.4), x2: rx, y2: Y(b.H + 1.4), stroke: '#653b4e', 'stroke-width': 0.3, 'stroke-dasharray': '1 1', opacity: 0.8 });
s += el('path', { d: 'M' + rx + ' ' + Y(b.H + 1.4) + 'l-2.4 -1.4v2.8z', fill: '#653b4e' });
marks.forEach(function (m) {
s += el('line', { x1: -40, y1: Y(m.h), x2: 24, y2: Y(m.h), stroke: '#653b4e', 'stroke-width': 0.3, 'stroke-dasharray': '1.2 1', opacity: 0.85 });
});
return s;
}
/* ---------- storage ---------- */
function load() {
try { var v = JSON.parse(localStorage.getItem(STORE_KEY)); if (v && v.h && v.w) return v; } catch (e) {}
return null;
}
function save(v) { try { localStorage.setItem(STORE_KEY, JSON.stringify({ h: v.h, w: v.w })); } catch (e) {} }
/* ---------- component ---------- */
function init(root) {
if (root.__elFit) return;
root.__elFit = true;
var data;
try { data = JSON.parse(root.querySelector('[data-el-fit-data]').textContent); } catch (e) { return; }
var p = profile(data);
if (!p.kind) { root.hidden = true; return; }
var lang = data.lang === 'ar' ? 'ar' : 'en';
var tr = T[lang];
var cfg = { p: p, t: tr };
var groups = colorGroups(data);
var stored = load();
var state = { h: stored ? stored.h : 160, w: stored ? stored.w : 65, touched: !!stored, colors: {} };
var uid = 'elfit' + Math.random().toString(36).slice(2, 7);
var ph = PHOTOS[data.handle] || null;
var view = ph ? 'photo' : 'draw';
/* usage events: open, result (after she stops moving the sliders), order */
function variantId() {
var i = document.querySelector('product-info form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] input[name="id"]');
var id = i ? +i.value : 0;
return id > 0 ? id : null;
}
function bandNow() { return fit(state.h, state.w, p).band; }
var sentResults = {};
var resultTimer = null;
function sendResult() {
clearTimeout(resultTimer);
resultTimer = null;
if (!state.touched) return;
var key = state.h + 'x' + state.w;
if (sentResults[key]) return;
sentResults[key] = true;
var b = bandNow();
var ev = { p: data.handle, vr: variantId(), h: state.h, w: state.w, b: b };
var root0 = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
var note = fmt('{h} سم، {w} كيلو، {v} ({p})', { h: state.h, w: state.w, v: T.ar.short[b], p: data.handle });
fetch(root0 + 'cart/update.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ attributes: { Mevy: note } })
}).then(function (r) { return r.json(); }).then(function (c) {
if (c && c.token) ev.t = String(c.token).split('?')[0].slice(0, 64);
}).catch(function () {}).then(function () { window.elTrack('result', ev); });
}
function queueResult() {
clearTimeout(resultTimer);
resultTimer = setTimeout(sendResult, 1500);
}
function pickColors() {
var fb = fallbackColor(data), top = null, pants = null, all = null;
groups.forEach(function (g) {
var sel = g.values.filter(function (v) { return v.selected; })[0] || g.values[0];
if (!sel) return;
if (g.role === 'top') top = sel.hex; else if (g.role === 'pants') pants = sel.hex; else all = all || sel.hex;
});
state.colors.top = top || all || fb;
state.colors.pants = pants || all || (p.kind === 'pants' ? fb : state.colors.top);
}
pickColors();
var thumb = root.querySelector('[data-el-fit-thumb]');
var sub = root.querySelector('[data-el-fit-teaser-sub]');
var dlg = root.querySelector('dialog');
var svg = root.querySelector('[data-el-fit-svg]');
var marksBox = root.querySelector('[data-el-fit-marks]');
var verdict = root.querySelector('[data-el-fit-verdict]');
var facts = root.querySelector('[data-el-fit-facts]');
var meter = root.querySelector('[data-el-fit-meter]');
var colorsBox = root.querySelector('[data-el-fit-colors]');
var inputs = {
h: { range: root.querySelector('[data-el-fit-range="h"]'), num: root.querySelector('[data-el-fit-num="h"]'), min: 140, max: 190 },
w: { range: root.querySelector('[data-el-fit-range="w"]'), num: root.querySelector('[data-el-fit-num="w"]'), min: 40, max: 130 }
};
/* real photos: switch, photo, caption, teaser thumb */
var mirror = root.querySelector('.el-fit__mirror');
var photo = null, photoNote = null, views = null, thumbImg = null, noteText = null, noteDraw = '', preloaded = false;
function photoUrl(b, w) { var u = ph.i[b]; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
function dropPhotos() {
if (!ph) return;
ph = null;
view = 'draw';
if (views) views.hidden = true;
if (photoNote) photoNote.hidden = true;
if (thumbImg) { thumbImg.remove(); thumbImg = null; thumb.style.display = ''; }
if (dlg.open) renderSheet();
}
if (ph) {
var stage = root.querySelector('.el-fit__stage');
views = document.createElement('div');
views.className = 'el-fit__views';
views.setAttribute('role', 'group');
views.innerHTML = '<button type="button" data-view="photo">' + tr.viewPhoto + '</button><button type="button" data-view="draw">' + tr.viewDraw + '</button>';
stage.insertBefore(views, stage.firstChild);
views.addEventListener('click', function (e) {
var b = e.target.closest('[data-view]');
if (!b || b.dataset.view === view) return;
view = b.dataset.view;
renderSheet();
});
photo = document.createElement('img');
photo.className = 'el-fit__photo';
photo.alt = tr.photoAlt;
photo.decoding = 'async';
photo.addEventListener('load', function () { photo.classList.remove('is-loading'); });
photo.addEventListener('error', dropPhotos);
mirror.appendChild(photo);
photoNote = document.createElement('p');
photoNote.className = 'el-fit__photo-note';
stage.appendChild(photoNote);
var noteEl = root.querySelector('.el-fit__note');
if (noteEl && noteEl.firstChild && noteEl.firstChild.nodeType === 3) { noteText = noteEl.firstChild; noteDraw = noteText.nodeValue; }
thumbImg = document.createElement('img');
thumbImg.className = 'el-fit__thumb-photo';
thumbImg.alt = '';
thumbImg.addEventListener('error', dropPhotos);
thumb.style.display = 'none';
thumb.parentNode.appendChild(thumbImg);
}
function renderThumb() {
var o = draw(state, cfg, { uid: uid + 't' });
var b = o.b;
var top = FLOOR - b.H - 4, bottom = FLOOR - b.crotch + 2;
thumb.setAttribute('viewBox', '-30 ' + r1(top) + ' 60 ' + r1(bottom - top));
thumb.innerHTML = o.svg;
if (thumbImg) {
var ts = photoUrl(o.fit.band, 160);
if (thumbImg.getAttribute('src') !== ts) thumbImg.src = ts;
}
if (state.touched) {
sub.textContent = fmt(tr.teaserDone, { h: state.h, w: state.w, v: tr.short[o.fit.band] });
}
if (typeof syncQuick === 'function') syncQuick();
}
function renderSheet() {
var o = draw(state, cfg, { uid: uid });
svg.innerHTML = o.svg + guides(o.b, o.marks);
svg.setAttribute('aria-label', fmt(tr.figureLabel, { h: state.h, w: state.w }));
var vbTop = 0, vbH = 200;
var pct = function (h) { return r1((FLOOR - h - vbTop) / vbH * 100); };
var html = '<span class="el-fit__mark el-fit__mark--h" style="top:' + pct(o.b.H + 1.4) + '%">' + fmt(tr.heightMark, { h: state.h }) + '</span>';
o.marks.forEach(function (m) {
html += '<span class="el-fit__mark el-fit__mark--hem" style="top:' + pct(m.h) + '%">' + m.label + '</span>';
});
marksBox.innerHTML = html;
var band = o.fit.band;
var vb = tr.bands[band];
var usePhoto = !!ph && view === 'photo';
mirror.classList.toggle('is-photo', usePhoto);
colorsBox.hidden = usePhoto || !groups.length;
if (views) {
views.querySelectorAll('[data-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.view === view ? 'true' : 'false'); });
photoNote.hidden = !usePhoto;
if (noteText) noteText.nodeValue = usePhoto ? tr.notePhoto + ' ' : noteDraw;
}
if (usePhoto) {
var src = photoUrl(band, 720);
if (photo.getAttribute('src') !== src) { photo.classList.add('is-loading'); photo.src = src; }
photoNote.textContent = fmt(tr.photoNote, { h: PHOTO_H, c: ph.c[lang === 'ar' ? 0 : 1] });
}
if (state.touched) {
verdict.innerHTML = '<strong>' + vb[0] + '</strong><span>' + fmt(vb[1], { max: p.max, min: p.min }) + '</span>';
verdict.classList.toggle('is-warn', band === 0);
verdict.classList.remove('is-idle');
} else {
verdict.innerHTML = '<strong>' + tr.start + '</strong>';
verdict.classList.add('is-idle');
verdict.classList.remove('is-warn');
}
meter.style.setProperty('--m', r1(clamp(o.fit.meter * 100, 3, 97)) + '%');
meter.classList.toggle('is-idle', !state.touched);
var rows = [o.topFact, o.sleeveFact, o.pantsFact];
if (p.kind === 'pants') rows.push([tr.waist, tr.waistElastic]);
facts.innerHTML = rows.filter(Boolean).map(function (r) { return '<li><span>' + r[0] + '</span><strong>' + r[1] + '</strong></li>'; }).join('');
renderThumb();
}
function setVal(k, v, fromNum) {
var c = inputs[k];
v = Math.round(clamp(+v || 0, c.min, c.max));
state[k] = v;
c.range.value = v;
c.range.style.setProperty('--p', r1((v - c.min) / (c.max - c.min) * 100) + '%');
if (!fromNum) c.num.value = v;
}
function touch() {
state.touched = true;
save(state);
queueResult();
}
Object.keys(inputs).forEach(function (k) {
var c = inputs[k];
setVal(k, state[k]);
c.range.addEventListener('input', function () { setVal(k, c.range.value); touch(); renderSheet(); });
c.num.addEventListener('input', function () {
if (c.num.value === '' || +c.num.value < c.min) return;
setVal(k, c.num.value, true); touch(); renderSheet();
});
c.num.addEventListener('change', function () { setVal(k, c.num.value); touch(); renderSheet(); });
root.querySelectorAll('[data-el-fit-step="' + k + '"]').forEach(function (btn) {
btn.addEventListener('click', function () { setVal(k, state[k] + (+btn.dataset.d)); touch(); renderSheet(); });
});
});
/* quick height/weight fields on the card itself (snippets/elite-fit.liquid) */
var quick = { h: root.querySelector('[data-el-fit-quick="h"]'), w: root.querySelector('[data-el-fit-quick="w"]') };
function syncQuick() {
Object.keys(quick).forEach(function (k) {
var q = quick[k];
if (!q || !state.touched) return;
if (+q.value !== state[k] && document.activeElement !== q) q.value = state[k];
});
}
Object.keys(quick).forEach(function (k) {
var q = quick[k];
if (!q) return;
var c = inputs[k];
function take(final) {
var v = +q.value;
if (!v || v < c.min) { if (final) q.value = state.touched ? state[k] : ''; return; }
if (v > c.max) { if (!final) return; v = c.max; }
setVal(k, v);
touch();
renderThumb();
if (final) q.value = state[k];
}
q.addEventListener('input', function () { take(false); });
q.addEventListener('change', function () { take(true); });
q.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); take(true); q.blur(); open(); } });
});
syncQuick();
/* colour chips mirror the page's colour picker */
function renderColors() {
if (!groups.length) { colorsBox.hidden = true; return; }
colorsBox.innerHTML = groups.map(function (g, gi) {
var sel = g.values.filter(function (v) { return v.selected; })[0] || g.values[0];
return '<div class="el-fit__colors-row"><span class="el-fit__colors-name">' + escapeHtml(g.name) + ': <b>' + escapeHtml(sel ? sel.name : '') + '</b></span><div class="el-fit__chips">' +
g.values.map(function (v, vi) {
return '<button type="button" class="el-fit__chip' + (v.selected ? ' is-on' : '') + '" style="--c:' + v.hex + '" data-g="' + gi + '" data-v="' + vi + '" aria-pressed="' + (v.selected ? 'true' : 'false') + '" aria-label="' + escapeHtml(v.name) + '"></button>';
}).join('') + '</div></div>';
}).join('');
}
function selectValue(gi, vi, syncPage) {
var g = groups[gi];
g.values.forEach(function (v, i) { v.selected = i === vi; });
pickColors();
renderColors();
renderSheet();
if (syncPage) choosePageOption(g.position, g.values[vi].name);
}
colorsBox.addEventListener('click', function (e) {
var btn = e.target.closest('.el-fit__chip');
if (!btn) return;
selectValue(+btn.dataset.g, +btn.dataset.v, true);
});
function pageInputs(position) {
var scope = document.querySelector('variant-selects') || document;
return Array.prototype.filter.call(scope.querySelectorAll('input[type="radio"], select'), function (i) {
if (i.tagName === 'SELECT') return i.id && i.id.slice(-2) === '-' + (position - 1);
return new RegExp('-' + position + '$').test(i.name);
});
}
function choosePageOption(position, value) {
var list = pageInputs(position);
list.forEach(function (i) {
if (i.tagName === 'SELECT') {
if (i.value !== value) { i.value = value; i.dispatchEvent(new Event('change', { bubbles: true })); }
} else if (i.value === value && !i.checked) {
i.click();
}
});
}
document.addEventListener('change', function (e) {
var i = e.target;
if (!i.closest || !i.closest('variant-selects')) return;
groups.forEach(function (g, gi) {
var list = pageInputs(g.position);
if (list.indexOf(i) === -1) return;
var val = i.tagName === 'SELECT' ? i.value : i.checked ? i.value : null;
if (val == null) return;
var vi = -1;
g.values.forEach(function (v, k) { if (v.name === val) vi = k; });
if (vi > -1) {
g.values.forEach(function (v, k) { v.selected = k === vi; });
pickColors();
renderColors();
renderThumb();
if (dlg.open) renderSheet();
}
});
});
/* open / close */
var openers = root.querySelectorAll('[data-el-fit-open]');
var opener = openers[0];
function open() {
if (ph && !preloaded) {
preloaded = true;
ph.i.forEach(function (u, b) { var im = new Image(); im.src = photoUrl(b, 720); });
}
renderColors();
renderSheet();
window.elTrack('open', { p: data.handle, vr: variantId() });
if (state.touched) queueResult();
if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
document.documentElement.classList.add('el-fit-lock');
}
function close() {
if (dlg.open) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
}
dlg.addEventListener('close', function () { document.documentElement.classList.remove('el-fit-lock'); opener.focus(); if (resultTimer) sendResult(); });
openers.forEach(function (b) { b.addEventListener('click', open); });
/* «مقاسك؟» in the sticky bar at the bottom of phones (sections/elite-styles.liquid): hidden until a fit card exists */
document.querySelectorAll('[data-el-bar-fit]').forEach(function (b) {
b.hidden = false;
b.addEventListener('click', function () { root.scrollIntoView({ block: 'center' }); open(); });
});
root.querySelectorAll('[data-el-fit-close]').forEach(function (b) { b.addEventListener('click', close); });
dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
root.querySelector('[data-el-fit-cta]').addEventListener('click', function () {
if (resultTimer) sendResult();
window.elTrack('order', state.touched ? { p: data.handle, vr: variantId(), h: state.h, w: state.w, b: bandNow() } : { p: data.handle, vr: variantId() });
close();
var buy = document.querySelector('.product-form__buttons .es-popup-button-product') ||
document.querySelector('.product-form__buttons [type="submit"]:not([disabled])');
if (buy) {
buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
setTimeout(function () { buy.click(); }, 350);
}
});
renderThumb();
/* links with ?mevy=1[&h=160&w=65] (home page, ads, card badges) open the sheet once, with her numbers filled in */
try {
var qs = new URLSearchParams(location.search);
if (qs.has('mevy') && !window.__elFitAuto) {
window.__elFitAuto = true;
var qh = +qs.get('h'), qw = +qs.get('w'), any = false;
if (qh >= inputs.h.min && qh <= inputs.h.max) { setVal('h', qh); any = true; }
if (qw >= inputs.w.min && qw <= inputs.w.max) { setVal('w', qw); any = true; }
if (any) { state.touched = true; save(state); syncQuick(); renderThumb(); }
['mevy', 'h', 'w'].forEach(function (k) { qs.delete(k); });
var clean = location.pathname + (qs.toString() ? '?' + qs.toString() : '') + location.hash;
if (history.replaceState) history.replaceState(null, '', clean);
setTimeout(function () { root.scrollIntoView({ block: 'center' }); root.classList.add('el-fit--hi'); setTimeout(function () { root.classList.remove('el-fit--hi'); }, 2600); }, 350);
}
} catch (e) {}
}
function escapeHtml(s) {
return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
}
function boot() { document.querySelectorAll('[data-el-fit]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
window.EliteFit = { profile: profile, fit: fit, body: body, draw: draw, T: T };
})();


